import * as React from "react";

const SignInIcon: React.FC = () => {
    return (
        <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.9039 23.284V20.808C20.9039 19.4947 20.3822 18.2351 19.4535 17.3064C18.5249 16.3777 17.2653 15.856 15.9519 15.856H6.05195C5.40131 15.8555 4.75694 15.9832 4.15567 16.2318C3.5544 16.4804 3.00803 16.8451 2.54777 17.305C2.08751 17.7649 1.72239 18.311 1.47328 18.912C1.22417 19.5131 1.09595 20.1574 1.09595 20.808V23.284"
                stroke="#1C355E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.9479 5.952C15.9479 6.93158 15.6574 7.88916 15.1131 8.7036C14.5688 9.51804 13.7952 10.1527 12.8901 10.5274C11.985 10.9021 10.9891 11 10.0284 10.8086C9.06768 10.6172 8.18533 10.1451 7.49294 9.45218C6.80055 8.75923 6.32923 7.87649 6.13861 6.91563C5.94799 5.95478 6.04663 4.95897 6.42205 4.05418C6.79746 3.14939 7.4328 2.37627 8.24767 1.83262C9.06255 1.28897 10.0204 0.99921 10.9999 1C12.3126 1.00106 13.5711 1.52326 14.499 2.45182C15.4268 3.38039 15.9479 4.63934 15.9479 5.952Z"
                stroke="#1C355E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default React.memo(SignInIcon);
